<template>
    <div class="card">
        <slot></slot>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.card
    position relative
    display flex
    flex-direction column
    flex 1 1 auto
    background-color white
    border-radius 5px
    box-shadow 0 2px 2px rgba(0, 0, 0, 0.2)
    padding 54px
    box-sizing border-box

    @media screen and (max-width: $mobile-step1-max-width)
        padding 24px

    &.as-button
        basic-button-v2(1, 0)

        &:hover
            background-color $color-primary
            color $color-primary-text

    &.section-size
        max-width 820px

    &.small-padding
        padding 24px

    > h1
    > hgroup > h1
        font-size 48px
        margin 0 !important

    > h2
    > hgroup > h2
        font-size 24px
        margin 0 !important

    h1+h2
        margin-top 0.5em !important

    h2+h3
        margin 0

    p
        line-height 24px

    &.dark
        background-color $color-secondary

    .card-content-image
        display flex
        flex-direction row
        align-items center

        & > *:not(:first-child)
            margin-left 24px

        img
            align-self flex-start
            width 320px

        .card-content-image-content
            display flex
            flex-direction column
            align-items stretch
            flex 1 1 auto

            .el-form
                margin-top 16px

    footer
        display flex
        flex-direction row
        flex 1 1 auto
        justify-content flex-start
        margin-top 48px

        .primary-button

            &:not(:first-child)
                margin-left 8px

        > *.push-right
            margin-left auto !important

        > *.push-left
            margin-right auto !important


    // &+footer
    //     display flex
    //     flex-direction row
    //     flex 1 1 auto
    //     justify-content flex-end
    //     background-color $color-blue-16
    //     border-radius 6px
    //     padding 16px 32px
    //     margin-top 16px

    //     .primary-button:not(:first-child)
    //         margin-left 8px
</style>



// WEBPACK FOOTER //
// src/components/v3/cards/Card.vue